<div class="image-bg mat-elevation-z1"
     (click)="onClickImage(Image)"
     [ngStyle]="{width: width, height: height}"
     [style.background-image]="imageSafe"></div>
<input #Image class="hidden" placeholder="Image" type="file" (change)="onChangeImage(Image)">
